import { useState, useCallback, useEffect } from 'react';
import { IncidentStatusService } from '../../../services/incidentStatusService';

const useServiceStatus = () => {
  const [serviceStatus, setServiceStatus] = useState([]);

  const getServiceStatus = useCallback(async () => {
    const data = await IncidentStatusService.getAll();
    setServiceStatus(data.serviceStatus);
  }, []);

  useEffect(() => {
    getServiceStatus();
  }, [getServiceStatus]);

  return {
    serviceStatus,
  };
};

export default useServiceStatus;
